<section id="about" class="about-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 order-lg-1 order-2">
        <div class="about-text animate-on-scroll">
          <span class="section-label d-block">{{ aboutData.sectionTitle }}</span>
          <h2 class="about-title">{{ aboutData.title }}</h2>
          <p class="about-description">{{ aboutData.description }}</p>
          <button 
            class="btn about-cta-btn" 
            (click)="navigateToIntake()"
            aria-label="Navigate to intake form"
          >
            {{ aboutData.ctaText }}
          </button>
        </div>
      </div>
      
      <div class="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0">
        <div class="about-image animate-on-scroll">
          <div class="image-wrapper">
            <img 
              [src]="aboutData.image" 
              alt="Professional team collaboration"
              loading="lazy"
              class="img-fluid"
            />
            <div class="image-overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>